import { render, staticRenderFns } from "./FnFormatPhone.vue?vue&type=template&id=29c98aec&"
import script from "./FnFormatPhone.vue?vue&type=script&lang=js&"
export * from "./FnFormatPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports